import patchRequest from '../../../../patchRequest';
/**
 * Updates the product type.
 * @param {number} siteId
 * @param {string} productTypeName
 * @param {string} departmentCode
 * @param {boolean} isDefault
 * @param {number[]} attributeDefIds
 * @returns {Promise} { Success: true }, status: 200 }
 */
export default async function patchProductType(
  body,
) {
  const endpoint = `/oc-data-management/v1/product-type/${body.productTypeId}/${body.siteId}`;

  const body1 = {
    productTypeName: body.productTypeName,
    departmentCode: body.departmentCode,
    isDefault: body.default,
    attributeDefs: body.attribute,
  };
  return new Promise((resolve, reject) => {
    patchRequest(endpoint, body1, 'Update product attribute')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
